
import { WINDOW_EVENTS } from '../../constants/events';


const loadDefault = { windowLoadComplete: false , updateDfp: false };

/**
 * Adding a state for window properties
 * @param {*} state
 * @param {*} actions
 */
const windowReducer = (state = loadDefault, actions) => {
  switch (actions.type) {
    case 'UPDATE_LOAD_STATUS':
      state = Object.assign({}, state, actions.payload);
      break;
    case 'UPDATE_PAYMENT_DATA':
      state = Object.assign({}, state, actions.payload);
      break;
    case WINDOW_EVENTS.REMOVE_ERROR_MESSAGE:
      state = Object.assign({}, state, actions.payload);
      break;
    case 'UPDATE_WINDOW_DATA':
      state = Object.assign({}, state, actions.payload);
    default:
      return state;
  }

  return state;
};

export default windowReducer;



// WEBPACK FOOTER //
// ../q-jobs/src/reducers/WindowReducer/index.js